@switch (columnName) {
  @case ('dateTime') {
    <span class="highlighted-text">
      {{ element.date | date }}
    </span>
    <span class="text-secondary">
      {{ element.date | date: timeFormat }}
    </span>
  }
  @case ('date') {
    <span class="highlighted-text">
      {{ element.date | date }}
    </span>
    <span class="text-secondary">
      {{ element.date | date: timeFormat }}
    </span>
  }
  @case ('startDate') {
    <span class="highlighted-text">
      {{ element.startDate | date }}
    </span>
    <span class="text-secondary">
      {{ element.startDate | date: timeFormat }}
    </span>
  }
  @case ('endDate') {
    <span class="highlighted-text">
      {{ element.endDate | date }}
    </span>
    <span class="text-secondary">
      {{ element.endDate | date: timeFormat }}
    </span>
  }
  @case ('comment') {
    <app-text-overflow-label [text]="element.comment"></app-text-overflow-label>
  }
  @case ('action') {
    {{ actionTranslationKey | translate }}
  }
  @case ('actionDoneBy') {
    {{ element.createdBy }}
  }
  @case ('logChanges') {
    @if (isNextOfKinAction) {
      @if (nextOfKinFieldChanges.length === 0) {
        <span class="highlighted-text bold-text">
          {{ nextOfKinSummaryTranslationKey | translate: { name: nextOfKinSubjectName } }}
        </span>
      } @else {
        <app-log-change-breakdown
          [titleKey]="nextOfKinSummaryTranslationKey"
          [titleParams]="{ name: nextOfKinSubjectName }"
          [changes]="nextOfKinFieldChanges"
        ></app-log-change-breakdown>
      }
    } @else if (logChangeItems.length > 0) {
      @for (item of logChangeItems; track $index) {
        @if (item.type === 'nextOfKinGroup') {
          <app-log-change-breakdown
            titleKey="nextOfKinNumber"
            [titleParams]="{ number: item.group.number }"
            [changes]="item.group.changes"
          ></app-log-change-breakdown>
        } @else {
          <div class="field-change">
            <span class="highlighted-text">
              {{
                item.change.labelKey || item.change.fieldName
                  | translate: item.change.translationParams
              }}
              {{ item.change.translationKey | translate }}
            </span>
            @if (item.change.items?.length) {
              <ul class="text-secondary">
                @for (relatedObject of item.change.items; track relatedObject.id) {
                  <li>
                    <app-text-overflow-label [text]="relatedObject.name"></app-text-overflow-label>
                  </li>
                }
              </ul>
            } @else if (item.change.value !== null && item.change.value !== '') {
              <span class="text-secondary">
                <app-text-overflow-label [text]="item.change.value"></app-text-overflow-label>
              </span>
            }
          </div>
        }
      }
    } @else {
      {{ actionDescriptionTranslationKey | translate }}
    }
    @if (element.comment) {
      <div class="field-change">
        <span class="highlighted-text">{{ 'adminLogComment' | translate }}</span>
        <span class="text-secondary">
          <app-text-overflow-label [text]="element.comment"></app-text-overflow-label>
        </span>
      </div>
    }
  }
}
